import { buildApiUrl, Type, sendPostRequest, ErrorResponse } from '@/api/api'
import { assertSchemaAndCoerce } from '@/shared/utils/schemas/assertions'
import { z } from 'zod'

const approveResponseSchema = z.object({
  Approved: z.number(),
  Rejected: z.array(z.string()),
})

export type ApproveResponse = z.infer<typeof approveResponseSchema>

export async function approveTariffs(groupKeys: string[], userId: string | undefined) {
  if (!userId) throw new Error('User ID is required to approve tariffs.')

  const url = buildApiUrl(Type.TariffManagement, `approve-tariffs?userId=${encodeURIComponent(userId)}`)

  try {
    const { data } = await sendPostRequest<ApproveResponse>(url, groupKeys)
    return assertSchemaAndCoerce(data, approveResponseSchema)
  } catch (error) {
    if (error instanceof ErrorResponse) {
      throw { data: error.body as ApproveResponse | null, response: error.response }
    }
    throw error
  }
}